import { NgModule } from '@angular/core';

import { AcceptProtocolStatusPipe } from './accept-protocol-status.pipe';
import { BankAccountNumberFormatPipe } from './bank-account-number-format.pipe';
import { BoolPipe } from './bool.pipe';
import { EmptyPipe } from './empty.pipe';
import { GetMonthNamePipe } from './get-month-name.pipe';
import { GetPropIndexInObjectPipe } from './get-prop-index-in-object.pipe';
import { GetRoutePathPipe } from './get-route-path.pipe';
import { HasPermissionPipe } from './has-permission.pipe';
import { HttpStatusPipe } from './http-status.pipe';
import { IncludesPipe } from './includes.pipe';
import { IsCheckedElementPipe } from './is-checked-element.pipe';
import { IsCurrentUserPipe } from './is-current-user.pipe';
import { JoinElementsFromArrayPipe } from './join-elements-from-array.pipe';
import { JoinPropsPipe } from './join-props.pipe';
import { JsonHighlightPipe } from './json-highlight.pipe';
import { JsonHighlightDiffPipe } from './json-higliht-diff.pipe';
import { KartotekaSaldoTextPipe } from './kartoteka-saldo-text.pipe';
import { MegabytesPipe } from './megabytes.pipe';
import { NierozliczonaKwotaTextPipe } from './nierozliczona-kwota-text.pipe';
import { StatusHEksportStudentPipe } from './polon/status-eksport-student.pipe';
import { StatusEksportuPipe } from './polon/status-eksportu.pipe';
import { PullAheadPipe } from './pull-ahead.pipe';
import { SaldoBgPipe } from './saldo-bg.pipe';
import { SaldoTextPipe } from './saldo-text.pipe';
import { StanOplatyTextPipe } from './stan-oplaty-text.pipe';
import { StatusKonfiguracjiTextPipe } from './status-konfiguracji-text.pipe';
import { StatusKonfiguracjiPipe } from './status-konfiguracji.pipe';
import { StatusPracyPipe } from './status-pracy.pipe';
import { StatusTextPipe } from './status-text.pipe';
import { StatusTerminuProtokoluPipe } from './studia/status-terminu-protokolu.pipe';
import { StatusSprawyStypendiaPipe } from './stypendia/status-sprawy.pipe';
import { StatusStudentaPipe } from './stypendia/status-studenta.pipe';
import { StatusWeryfikacjiNazwaPipe } from './stypendia/status-weryfikacji-nazwa.pipe';
import { StatusWeryfikacjiOswiadczeniaODochodachPipe } from './stypendia/status-weryfikacji-oswiadczenia-o-dochodach.pipe';
import { StatusWeryfikacjiZgodnosciZOryginalemStypendiaPipe } from './stypendia/status-weryfikacji-zgodnosci-z-oryginalem.pipe';
import { StatusWezwaniaStypendiaPipe } from './stypendia/status-wezwania.pipe';
import { StatusWnioskuPipe } from './stypendia/status-wniosku.pipe';
import { StatusZawiadomieniaStypendiaPipe } from './stypendia/status-zawiadomienia.pipe';
import { TrimHtmlPipe } from './trim-html.pipe';
import { TruncatePipe } from './truncate.pipe';
import { UnixTimestampPipe } from './unix-timestamp.pipe';
import { UserTimezoneDatePipe } from './user-timezone-date.pipe';
import { UserTimezoneRangeDatePipe } from './user-timezone-range-date.pipe';
import { StatusPodaniaPipe } from './wnioski/status-podania.pipe';
import { StatusSprawyPipe } from './wnioski/status-sprawy.pipe';
import { StatusWeryfikacjiZgodnosciZOryginalemPipe } from './wnioski/status-weryfikacji-zgodnosci-z-oryginalem.pipe';
import { StatusWezwaniaPipe } from './wnioski/status-wezwania.pipe';
import { StatusWnioskuODodatkoweSwiadczeniePipe } from './wnioski/status-wniosku-ododatkowe-swiadczenie.pipe';
import { StatusZawiadomieniaPipe } from './wnioski/status-zawiadomienia.pipe';

const pipes = [
  JoinPropsPipe,
  GetRoutePathPipe,
  PullAheadPipe,
  AcceptProtocolStatusPipe,
  BankAccountNumberFormatPipe,
  BoolPipe,
  EmptyPipe,
  GetMonthNamePipe,
  GetPropIndexInObjectPipe,
  HasPermissionPipe,
  IsCheckedElementPipe,
  JoinElementsFromArrayPipe,
  StatusKonfiguracjiPipe,
  StatusKonfiguracjiTextPipe,
  StatusPodaniaPipe,
  StatusPracyPipe,
  StatusSprawyPipe,
  StatusSprawyStypendiaPipe,
  StatusStudentaPipe,
  StatusTerminuProtokoluPipe,
  StatusTextPipe,
  StatusWeryfikacjiNazwaPipe,
  StatusWeryfikacjiOswiadczeniaODochodachPipe,
  StatusWeryfikacjiZgodnosciZOryginalemPipe,
  StatusWeryfikacjiZgodnosciZOryginalemStypendiaPipe,
  StatusWezwaniaPipe,
  StatusWezwaniaStypendiaPipe,
  StatusWnioskuODodatkoweSwiadczeniePipe,
  StatusWnioskuPipe,
  StatusZawiadomieniaPipe,
  StatusZawiadomieniaStypendiaPipe,
  TrimHtmlPipe,
  TruncatePipe,
  UnixTimestampPipe,
  UserTimezoneDatePipe,
  StatusEksportuPipe,
  StatusHEksportStudentPipe,
  IncludesPipe,
  MegabytesPipe,
  SaldoTextPipe,
  StanOplatyTextPipe,
  SaldoBgPipe,
  NierozliczonaKwotaTextPipe,
  IsCurrentUserPipe,
  UserTimezoneRangeDatePipe,
  KartotekaSaldoTextPipe,
  JsonHighlightPipe,
  JsonHighlightDiffPipe,
  HttpStatusPipe,
];
@NgModule({
  declarations: pipes,
  exports: pipes,
})
export class PipesModule {}
